import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent'

// New Relic Browser RUM.
// Mirrors the GA4 pattern in usePageTracking.ts: configured via VITE_* env vars
// and initialized only when present. The "license key" is New Relic's public
// browser ingest key, designed to ship in client JS.
type NewRelicEnv = {
  application_id: string
  license_key: string
  account_id: string
  trust_key: string
}

export const createNewRelicAgent = ({
  application_id,
  license_key,
  account_id,
  trust_key,
}: NewRelicEnv): BrowserAgent | undefined => {
  if (!application_id || !license_key) return undefined

  return new BrowserAgent({
    info: {
      applicationID: application_id,
      beacon: 'bam.nr-data.net',
      errorBeacon: 'bam.nr-data.net',
      licenseKey: license_key,
      sa: 1,
    },
    init: {
      ajax: { deny_list: ['bam.nr-data.net'] },
      browser_consent_mode: { enabled: false },
      distributed_tracing: { enabled: true },
      performance: {
        capture_detail: false,
        capture_marks: false,
        capture_measures: true,
      },
      privacy: { cookies_enabled: true },
    },
    loader_config: {
      accountID: Number(account_id),
      agentID: Number(application_id),
      applicationID: Number(application_id),
      licenseKey: license_key,
      trustKey: Number(trust_key),
    },
  })
}

const agent = createNewRelicAgent({
  application_id: import.meta.env.VITE_NEWRELIC_APPLICATION_ID as string,
  license_key: import.meta.env.VITE_NEWRELIC_LICENSE_KEY as string,
  account_id: import.meta.env.VITE_NEWRELIC_ACCOUNT_ID as string,
  trust_key: import.meta.env.VITE_NEWRELIC_TRUST_KEY as string,
})

export const setNewRelicRouteNameForAgent = (target_agent: BrowserAgent | undefined, name: string) => {
  target_agent?.setCurrentRouteName(name)
}

// Report a logical SPA route name to New Relic. No-op when the agent is disabled.
export const setNewRelicRouteName = (name: string) => {
  setNewRelicRouteNameForAgent(agent, name)
}
